import Delete from '@mui/icons-material/Delete';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DeleteIcon(props: FixMe) {
  return <Delete {...props} />;
}

export default DeleteIcon;
